import axios from "axios";
import URLS from "../modules/util/urls.js";

const state = {

}

const mutations = {

}

const actions = {
  gerarBoletoAvulso(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_GERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
        case "FALHA":
        case "ERRO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("gerarBoletoAvulso", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },
  gerarBoletosEmAberto(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_GERAR_BOLETOS, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
        case "FALHA":
        case "ERRO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("gerarBoletosEmAberto", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },
  enviarBoletoAvulso(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_ENVIAR_BOLETO_POR_EMAIL, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('enviarBoletoAvulso', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  enviarBoletosAvulsos(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_ENVIAR_BOLETOS_EM_ABERTO_POR_EMAIL, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('enviarBoletosAvulsos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarBoletosAvulsos(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarBoletosAvulsos", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  }
}

export default {
  state,
  mutations,
  actions
}